export enum ModeEnum {
    VIEW = "view",
    EDIT = "edit",
    ONLY_MY_RECORDS = "only_my_records"
}


 